import { apiClient } from './clienteHttp';
import type { ColumnasExcelPreferencia } from './types';

export async function getColumnasExcelPreferencia(): Promise<ColumnasExcelPreferencia> {
  const { data } = await apiClient.get('/preferencias/columnas-excel');
  return data;
}

export async function guardarColumnasExcelPreferencia(
  seleccion: Record<string, boolean>,
): Promise<{ seleccion: Record<string, boolean> }> {
  const { data } = await apiClient.put('/preferencias/columnas-excel', { seleccion });
  return data;
}
